// getProfileFeedUnixTimestamp.js
'use strict';
import getMeData from '../selector/getMeData.js';
import getOperationData from '../selector/getOperationData.js';
import getUserLatestMessage from '../selector/getUserLatestMessage.js';

import createCachedSelector from '../resource/createCachedSelector.js';
import { ProfileListType } from '../resource/profileConstants.js';

/**
 * Select profile feed unix timestamp by list type
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} userId - user id.
 * @param {ProfileListType} listType - profile list type.
 * @return {number|undefined} The selected profile feed unix timestamp.
 */
const getProfileFeedUnixTimestamp = createCachedSelector(
  (state, userId) => getMeData(state, 'id') === userId,
  state => getOperationData(state, ['profileFeed'], 'unixTimestamp'),
  (state, userId) => getUserLatestMessage(state, userId, 'postedAt'),
  (state, userId, listType) => listType,
  (isMe, profileFeedUnixTimestamp, storyFeedUnixTimestamp, listType) => {
    if (isMe) {
      return profileFeedUnixTimestamp;
    }
    if (ProfileListType.STORY === listType) {
      return storyFeedUnixTimestamp;
    }
    return;
  }
)((state, userId, listType) => `${userId}:${listType}`);

export default getProfileFeedUnixTimestamp;
